import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
@Injectable()
export class Urls {
	forQualifyProductFields()
	{
		return this.getServer() + "/api/Admin/Qualify/Product/fields";
	}
	forQualifyProductCall()
	{
		return this.getServer() + "/api/Admin/Qualify/Product/call";
	}
	forNewServiceFields()
	{
		return this.getServer() + "/api/Admin/New/Service/fields";
	}
	forNewServiceCall()
	{
		return this.getServer() + "/api/Admin/New/Service/call";
	}
	private getServer()
	{
		return  environment.server;
	}
}



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/urls.ts